import request from '@/request/http'

///获取指令列表
export function getMyInstructionList(id) {
  return request({
      url: `ai/instruction/getMyInstructionList?userName=${id}` ,
      method: 'get',
      // data: data
  })
}

///修改指令
export function updateMyInstruction(data) {
  return request({
      url: `ai/instruction/updateMyInstruction` ,
      method: 'put',
      data: data
  })
}


///新增指令
export function addMyInstruction(data) {
  return request({
      url: `ai/instruction/addMyInstruction` ,
      method: 'post',
      data: data
  })
}

///删除指令
export function delInstruction(id) {
  return request({
      url: `ai/instruction/delInstruction/${id}` ,
      method: 'DELETE',
     // data: data
  })
}


